type JoinInviteController = {
  present: (token: string) => void;
};

let controller: JoinInviteController | null = null;

export function registerJoinInviteController(next: JoinInviteController | null): void {
  controller = next;
}

/** Re-open the join household modal (notification tap / deep link). */
export function openJoinInvite(token: string): boolean {
  const trimmed = token.trim();
  if (!trimmed || !controller) return false;
  controller.present(trimmed);
  return true;
}
